(function () {
  'use strict';

  function initReadMore() {
    try {
      var desc = document.querySelector('.collection-hero__description');
      if (!desc) return;

      var styles = window.getComputedStyle(desc);
      var lineHeight = parseFloat(styles.lineHeight);
      if (!lineHeight || isNaN(lineHeight)) {
        var fontSize = parseFloat(styles.fontSize) || 16;
        lineHeight = fontSize * 1.5;
      }

      var maxLines = window.matchMedia('(max-width: 749px)').matches ? 1 : 3;
      var maxHeight = lineHeight * maxLines + 8;
      if (desc.scrollHeight <= maxHeight) return;

      desc.classList.add('rl-clamped');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rl-readmore-btn';
      btn.textContent = 'Read more';
      if (!desc.id) desc.id = 'RunItCollectionDescription';
      btn.setAttribute('aria-controls', desc.id);
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var clamped = desc.classList.toggle('rl-clamped');
        btn.textContent = clamped ? 'Read more' : 'Read less';
        btn.setAttribute('aria-expanded', String(!clamped));
      });

      if (desc.parentNode) {
        desc.parentNode.insertBefore(btn, desc.nextSibling);
      }
    } catch (e) {
      // never throw
    }
  }

  function initHeroLinks() {
    try {
      ['__image_banner_bPRRmp', '__image_banner_BLpPRA'].forEach(function (suffix) {
        var section = document.querySelector('[id^="shopify-section-"][id$="' + suffix + '"]');
        if (!section || section.querySelector('.rl-hero-link')) return;
        var a = document.createElement('a');
        a.href = '/collections';
        a.className = 'rl-hero-link';
        a.setAttribute('aria-label', 'Shop the store');
        a.textContent = 'Shop the store';
        section.appendChild(a);
      });
    } catch (e) {
      // never throw
    }
  }

  function initVariantDetails() {
    var info = document.querySelector('product-info[id^="ProductInfo-"]');
    var details = info && info.querySelector('[data-runit-purchase-details]');
    var form = info && info.querySelector('form[action*="/cart/add"]:has(button[name="add"])');
    if (!details || !form || info.dataset.runitVariantDetails) return;
    var matchPath = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!matchPath) return;
    fetch((window.Shopify.routes.root || '/') + 'products/' + matchPath[1] + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;
        info.dataset.runitVariantDetails = 'true';
        var byId = {};
        var priceById = {};
        product.variants.forEach(function (variant) { byId[variant.id] = variant; });
        details.querySelectorAll('[data-runit-variant]').forEach(function (row) {
          priceById[row.dataset.variantId] = row.dataset;
        });
        var names = product.options.map(function (option) { return option.name || option; });
        var printIndex = names.findIndex(function (name) { return name.toLowerCase() === 'print type'; });
        var delivery = details.querySelector('[data-runit-delivery]');
        var toggle = null;
        var lastId = null;

        function switchTo(variant) {
          var picker = info.querySelector('variant-selects, variant-radios');
          if (!picker) return;
          variant.options.forEach(function (value, index) {
            var radio = picker.querySelector('input[type="radio"][name="' + CSS.escape(names[index]) + '"][value="' + CSS.escape(value) + '"]');
            if (radio) {
              if (!radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
              return;
            }
            var select = picker.querySelectorAll('select')[index];
            if (select && select.value !== value) {
              select.value = value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }

        if (printIndex >= 0) {
          var radio = info.querySelector('.product-form__input--pills input[name="' + CSS.escape(names[printIndex]) + '"]');
          var row = radio && radio.closest('.product-form__input--pills');
          if (row && !row.querySelector('.rl-toggle')) {
            toggle = document.createElement('div');
            toggle.className = 'rl-toggle';
            row.appendChild(toggle);
            row.classList.add('rl-has-toggle');
          }
        }

        function render() {
          var input = form.querySelector('[name="id"]');
          var selected = input && byId[input.value];
          delivery.hidden = !selected || !selected.available;
          if (!selected) {
            lastId = null;
            if (toggle) toggle.querySelectorAll('button').forEach(function (button) {
              button.disabled = true;
              button.classList.remove('rl-tbtn--sel');
              button.setAttribute('aria-pressed', 'false');
            });
            return;
          }
          if (!toggle || lastId === selected.id) return;
          lastId = selected.id;
          var focusedValue = toggle.contains(document.activeElement) ? document.activeElement.dataset.printValue : null;
          toggle.replaceChildren();
          var values = [];
          product.variants.forEach(function (variant) {
            if (values.indexOf(variant.options[printIndex]) === -1) values.push(variant.options[printIndex]);
          });
          values.forEach(function (value) {
            var variant = product.variants.find(function (candidate) {
              return candidate.options.every(function (option, index) {
                return option === (index === printIndex ? value : selected.options[index]);
              });
            });
            var button = document.createElement('button');
            button.type = 'button';
            button.dataset.printValue = value;
            button.className = 'rl-tbtn';
            var active = selected.options[printIndex] === value;
            button.classList.toggle('rl-tbtn--sel', active);
            button.setAttribute('aria-pressed', String(active));
            button.disabled = !variant || !variant.available;
            button.innerHTML = '<span class="rl-tbtn-name"></span><span class="rl-tbtn-right"><span class="rl-tbtn-price"></span></span>';
            button.querySelector('.rl-tbtn-name').textContent = value;
            var entry = variant && priceById[variant.id];
            var price = button.querySelector('.rl-tbtn-price');
            price.textContent = entry ? entry.price : '';
            if (variant && variant.compare_at_price > variant.price && entry) {
              var compare = document.createElement('s');
              compare.textContent = entry.comparePrice;
              price.appendChild(compare);
            }
            if (button.disabled) {
              var status = document.createElement('span');
              status.className = 'rl-tbtn-oos-label';
              status.textContent = variant ? 'Sold out' : 'Unavailable';
              button.querySelector('.rl-tbtn-right').appendChild(status);
            } else {
              button.addEventListener('click', function () { switchTo(variant); });
            }
            toggle.appendChild(button);
            if (focusedValue === value && !button.disabled) button.focus({ preventScroll: true });
          });
        }
        render();
        info.addEventListener('change', function () {
          delivery.hidden = true;
          setTimeout(render, 60);
        });
        // ponytail: native variant updates sometimes emit no event; replace polling when all theme events are verified.
        setInterval(render, 1000);
      })
      .catch(function () { /* The native variant picker and server-rendered note remain available. */ });
  }

  function initHangingQuote() {
    try {
      var t = document.querySelector('.product__info-wrapper h1, .product__title h1, h1.product__title');
      if (t && /^["“‘']/.test(t.textContent.trim())) {
        t.classList.add('rl-hang-quote');
      }
    } catch (e) {
      // never throw
    }
  }

  function init() {
    initReadMore();
    initHeroLinks();
    initVariantDetails();
    initHangingQuote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
